import { empresasDelPerfil, esMapa } from './accessPolicy';
import { normalizarRol } from './roles';
import { leerUsuario, leerOperacion } from './legacyData';

export function normalizarUsuarioOperativo(data, uid = data?.id) {
  const usuario = leerUsuario(data, uid);
  return usuario ? { ...usuario, activo: usuario.activo !== false, perfil: usuario } : null;
}
export function usuarioValidoParaAtribucion(usuario, evento, modulo) {
  if (!usuario || !['rrpp', 'imagen'].includes(usuario.rol) || !usuario.activo || !usuario.nombre || !usuario.empresaId || !evento?.empresaId) return false;
  const p = usuario.perfil;
  if (p.eventosBloqueados?.[evento.id] === true) return false;
  const permisos = esMapa(p.eventosPermitidos) ? p.eventosPermitidos : {};
  if (Object.prototype.hasOwnProperty.call(permisos, evento.id)) return permisos[evento.id]?.[modulo] === true;
  return empresasDelPerfil(p).includes(evento.empresaId);
}
export function snapshotAtribucion(usuario) {
  return usuario ? { atribuidoAUid: usuario.id, atribuidoANombre: usuario.nombre, atribuidoARol: usuario.rol }
    : { atribuidoAUid: null, atribuidoANombre: '', atribuidoARol: '' };
}
export function snapshotCreador(usuario, uid = usuario?.uid || usuario?.id) {
  if (!uid || !usuario?.nombre || !usuario?.rol) throw new Error('No se pudo verificar la identidad del creador.');
  return { creadoPorUid: uid, creadoPorNombre: usuario.nombre, creadoPorRol: normalizarRol(usuario.rol) };
}
export function beneficiarioFuturo(operacion) {
  return operacion.atribuidoAUid ?? operacion.creadoPorUid;
}
export function nombreAtribuido(registro) {
  return leerOperacion(registro).atribuidoANombre || '—';
}
export function etiquetaRelacionador(usuario) {
  return usuario.nombre;
}
const errorIdentidad = (message) => Object.assign(new Error(message), { code: 'identity/invalid-promoter' });
export function resolverAtribucion(usuarios, uidSeleccionado, evento, modulo, { requerida = false, uid = '', rol = '' } = {}) {
  const propia = ['rrpp', 'imagen'].includes(normalizarRol(rol));
  const usuario = usuarios.find((p) => p.id === (propia ? uid : uidSeleccionado));
  if (propia && uidSeleccionado && uidSeleccionado !== uid) throw errorIdentidad('Solo puedes atribuir operaciones a tu propia cuenta.');
  if (!usuario) {
    if (propia || uidSeleccionado || requerida) throw errorIdentidad('Selecciona un usuario registrado activo autorizado para este evento.');
    return snapshotAtribucion(null);
  }
  if (!usuarioValidoParaAtribucion(usuario, evento, modulo)) throw errorIdentidad('El usuario no está activo o autorizado para este evento/módulo.');
  return snapshotAtribucion(usuario);
}
